import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { initialMotorSensoryAssessmentState } from '../store/motoSensoryAssessment.reducers'
import { setMotorSensory } from '../store/motoSensoryAssessment.actions'

export function* getMotorSensory(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const prNabc = pcrDoc.prNabc
    const motorSensoryItems = getSelectedDataFromObject(prNabc, Object.keys(initialMotorSensoryAssessmentState))
    const motorSensory = {
      ...motorSensoryItems,
    }
    if (motorSensory && Object.keys(motorSensory).length !== 0) {
      yield put(setMotorSensory(motorSensoryItems))
    }
  }
}
